var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGroupVideoCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.07,
    x2: 317.354,
    xlinkHref: "#lg1",
    y1: 110.869,
    y2: 360.622
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.416,
    x2: 337.64,
    xlinkHref: "#lg2",
    y1: 104.064,
    y2: 298.288
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 362.568,
    y2: 421.334
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 402.472,
    y2: 426.272
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 407.161,
    y2: 390.645
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 331.093,
    y2: 382.513
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ebac5"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.244,
    x2: 445.471,
    xlinkHref: "#lg3",
    y1: 136.503,
    y2: 245.73
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.781,
    x2: 236.111,
    xlinkHref: "#lg3",
    y1: 252.818,
    y2: 357.148
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.366,
    x2: 159.403,
    y1: 185.218,
    y2: 229.961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.805,
    x2: 124.319,
    xlinkHref: "#lg4",
    y1: 141.518,
    y2: 151.032
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.332,
    x2: 194.645,
    xlinkHref: "#lg4",
    y1: 139.711,
    y2: 153.024
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.871,
    x2: 188.302,
    xlinkHref: "#lg4",
    y1: 147.217,
    y2: 147.217
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe99a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd4755"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.084,
    x2: 167.089,
    xlinkHref: "#lg5",
    y1: 172.513,
    y2: 172.513
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.493,
    x2: 145.605,
    xlinkHref: "#lg1",
    y1: 145.17,
    y2: 145.17
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.567,
    x2: 173.68,
    xlinkHref: "#lg1",
    y1: 145.17,
    y2: 145.17
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa9b1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#ffa78f"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.086,
    x2: 154.086,
    xlinkHref: "#lg6",
    y1: 149.596,
    y2: 159.547
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d78878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca6e59"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.664,
    x2: 181.968,
    xlinkHref: "#lg7",
    y1: 108.985,
    y2: 128.289
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.5,
    x2: 170.536,
    xlinkHref: "#lg7",
    y1: 118.167,
    y2: 118.167
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.194,
    x2: 361.231,
    y1: 185.218,
    y2: 229.961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e9af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fc123"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.034,
    x2: 323.034,
    xlinkHref: "#lg8",
    y1: 112.681,
    y2: 131.681
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.266,
    x2: 413.215,
    xlinkHref: "#lg8",
    y1: 105.132,
    y2: 139.08
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.633,
    x2: 326.147,
    xlinkHref: "#lg4",
    y1: 141.518,
    y2: 151.032
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.16,
    x2: 396.473,
    xlinkHref: "#lg4",
    y1: 139.711,
    y2: 153.024
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.699,
    x2: 390.129,
    xlinkHref: "#lg4",
    y1: 147.217,
    y2: 147.217
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.911,
    x2: 368.917,
    xlinkHref: "#lg5",
    y1: 172.513,
    y2: 172.513
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.321,
    x2: 347.433,
    xlinkHref: "#lg1",
    y1: 145.17,
    y2: 145.17
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.395,
    x2: 375.507,
    xlinkHref: "#lg1",
    y1: 145.17,
    y2: 145.17
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.914,
    x2: 355.914,
    xlinkHref: "#lg6",
    y1: 149.596,
    y2: 159.547
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.283,
    x2: 345.318,
    xlinkHref: "#lg8",
    y1: 115.115,
    y2: 137.151
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.397,
    x2: 384.376,
    xlinkHref: "#lg8",
    y1: 103.001,
    y2: 136.98
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.608,
    x2: 154.232,
    xlinkHref: "#lg1",
    y1: 250.334,
    y2: 292.958
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.366,
    x2: 159.403,
    xlinkHref: "#lg5",
    y1: 313.589,
    y2: 358.332
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.805,
    x2: 124.319,
    xlinkHref: "#lg4",
    y1: 269.889,
    y2: 279.403
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.332,
    x2: 194.645,
    xlinkHref: "#lg4",
    y1: 268.082,
    y2: 281.395
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.871,
    x2: 188.302,
    xlinkHref: "#lg4",
    y1: 275.588,
    y2: 275.588
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.084,
    x2: 167.089,
    xlinkHref: "#lg5",
    y1: 300.884,
    y2: 300.884
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.493,
    x2: 145.605,
    xlinkHref: "#lg1",
    y1: 273.541,
    y2: 273.541
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.567,
    x2: 173.68,
    xlinkHref: "#lg1",
    y1: 273.541,
    y2: 273.541
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.086,
    x2: 154.086,
    xlinkHref: "#lg6",
    y1: 277.967,
    y2: 287.918
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.142,
    x2: 171.766,
    xlinkHref: "#lg1",
    y1: 232.8,
    y2: 275.424
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.194,
    x2: 361.231,
    xlinkHref: "#lg8",
    y1: 313.589,
    y2: 358.332
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb9c8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb5d4c"
  }))), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.633,
    x2: 326.147,
    xlinkHref: "#lg9",
    y1: 269.889,
    y2: 279.403
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.16,
    x2: 396.473,
    xlinkHref: "#lg9",
    y1: 268.082,
    y2: 281.395
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.699,
    x2: 390.129,
    xlinkHref: "#lg9",
    y1: 275.588,
    y2: 275.588
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.914,
    x2: 355.914,
    y1: 276.592,
    y2: 294.599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a44f3e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#6d3326"
  }))), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.914,
    x2: 355.914,
    xlinkHref: "#lg2",
    y1: 296.509,
    y2: 302.851
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.774,
    x2: 345.887,
    xlinkHref: "#lg1",
    y1: 272.672,
    y2: 272.672
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.941,
    x2: 382.054,
    xlinkHref: "#lg1",
    y1: 272.672,
    y2: 272.672
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.447,
    x2: 363.05,
    xlinkHref: "#lg1",
    y1: 234.572,
    y2: 259.175
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m456.744 71.883h-403.488c-8.838 0-16.003 7.165-16.003 16.003v271.528h435.494v-271.528c0-8.838-7.165-16.003-16.003-16.003z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.741 87.274h-371.482c-8.887 0-16.091 7.204-16.091 16.091v224.568c0 8.887 7.204 16.091 16.091 16.091h371.482c8.887 0 16.091-7.204 16.091-16.091v-224.569c-.001-8.886-7.205-16.09-16.091-16.09z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m469.851 357.321h-429.702c-4.273 0-8.253 2.172-10.566 5.765l-24.871 38.643c-1.657 2.575.191 5.963 3.253 5.963h494.069c3.062 0 4.91-3.388 3.253-5.963l-24.871-38.643c-2.312-3.593-6.292-5.765-10.565-5.765z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.259 438.117h-478.518c-8.694 0-15.741-7.047-15.741-15.74v-9.444c0-8.693 7.047-15.741 15.741-15.741h478.518c8.693 0 15.741 7.047 15.741 15.741v9.444c0 8.693-7.047 15.74-15.741 15.74z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.815 387.048h50.37c5.216 0 9.444 4.228 9.444 9.444 0 5.216-4.228 9.444-9.444 9.444h-50.37c-5.216 0-9.444-4.228-9.444-9.444-.001-5.216 4.228-9.444 9.444-9.444z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.184 375.81-10.401-18.489h-387.566l-10.401 18.489c-1.947 3.462.554 7.739 4.526 7.739h399.316c3.972 0 6.474-4.277 4.526-7.739z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m456.828 103.364v112.284h-201.828v-128.371h185.741c8.888 0 16.087 7.199 16.087 16.087z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 215.648v128.371h-185.741c-8.888 0-16.087-7.199-16.087-16.087v-112.284z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m111.097 215.648c0-18.897 15.319-34.215 34.215-34.215h17.546c18.897 0 34.215 15.319 34.215 34.215z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m111.324 146.632c0-5.594 3.883-10.281 9.101-11.513 1.395-.329 2.728.749 2.728 2.182v18.66c0 1.433-1.333 2.512-2.728 2.182-5.218-1.23-9.101-5.917-9.101-11.511z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.848 146.632c0-5.594-3.883-10.281-9.101-11.513-1.395-.329-2.728.749-2.728 2.182v18.66c0 1.433 1.333 2.512 2.728 2.182 5.218-1.23 9.101-5.917 9.101-11.511z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m154.086 190.206c-18.897 0-34.215-15.319-34.215-34.215v-17.546c0-18.897 15.319-34.215 34.215-34.215 18.897 0 34.215 15.319 34.215 34.215v17.546c.001 18.896-15.318 34.215-34.215 34.215z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.086 179.159c-6.285 0-11.552-4.363-12.936-10.226-.37-1.567.842-3.065 2.452-3.065h20.967c1.61 0 2.822 1.498 2.452 3.065-1.383 5.863-6.65 10.226-12.935 10.226z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m140.049 152.151c-3.069 0-5.556-2.488-5.556-5.556v-2.849c0-3.069 2.488-5.556 5.556-5.556 3.069 0 5.556 2.488 5.556 5.556v2.849c0 3.069-2.487 5.556-5.556 5.556z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.123 152.151c-3.069 0-5.556-2.488-5.556-5.556v-2.849c0-3.069 2.488-5.556 5.556-5.556 3.069 0 5.556 2.488 5.556 5.556v2.849c.001 3.069-2.487 5.556-5.556 5.556z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m155.976 160.231h-3.78c-3.151 0-5.536-2.847-4.984-5.949l2.167-12.182h9.414l2.167 12.182c.552 3.102-1.833 5.949-4.984 5.949z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m162.201 117.311c0 10.982 8.902 19.884 19.884 19.884h10.057c0-10.893-4.578-20.714-11.914-27.649-6.812-6.439-18.027-1.609-18.027 7.765z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.536 110.271c0-4.956-3.477-9.206-8.319-10.261-2.62-.57-5.34-.871-8.131-.871h-24.558c-10.509 0-19.028 8.519-19.028 19.028 0 10.509 8.519 19.028 19.028 19.028h14.084c14.87 0 26.924-12.054 26.924-26.924z",
    fill: "url(#SVGID_18_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m312.925 215.648c0-18.897 15.319-34.215 34.215-34.215h17.546c18.897 0 34.215 15.319 34.215 34.215z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m316.763 97.226c-13.733-.26-24.974 11.312-24.974 25.047v14.698c0 5.109 4.141 9.25 9.25 9.25 5.109 0 9.25-4.141 9.25-9.25v-5.569c0-8.211 6.31-15.277 14.513-15.663 8.757-.412 15.987 6.566 15.987 15.233v-9.25c0-13.374-10.714-24.244-24.026-24.496z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.065 97.226c13.733-.26 24.974 11.312 24.974 25.047v14.698c0 5.109-4.141 9.25-9.25 9.25-5.109 0-9.25-4.141-9.25-9.25v-5.569c0-8.211-6.31-15.277-14.513-15.663-8.757-.412-15.987 6.566-15.987 15.233v-9.25c0-13.374 10.714-24.244 24.026-24.496z",
    fill: "url(#SVGID_21_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m313.152 146.632c0-5.594 3.883-10.281 9.101-11.513 1.395-.329 2.728.749 2.728 2.182v18.66c0 1.433-1.333 2.512-2.728 2.182-5.218-1.23-9.101-5.917-9.101-11.511z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.676 146.632c0-5.594-3.883-10.281-9.101-11.513-1.395-.329-2.728.749-2.728 2.182v18.66c0 1.433 1.333 2.512 2.728 2.182 5.218-1.23 9.101-5.917 9.101-11.511z",
    fill: "url(#SVGID_23_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m355.914 190.206c-18.897 0-34.215-15.319-34.215-34.215v-17.546c0-18.897 15.319-34.215 34.215-34.215 18.897 0 34.215 15.319 34.215 34.215v17.546c0 18.896-15.318 34.215-34.215 34.215z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.914 179.159c-6.285 0-11.552-4.363-12.936-10.226-.37-1.567.842-3.065 2.452-3.065h20.967c1.61 0 2.822 1.498 2.452 3.065-1.383 5.863-6.65 10.226-12.935 10.226z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m341.877 152.151c-3.069 0-5.556-2.488-5.556-5.556v-2.849c0-3.069 2.488-5.556 5.556-5.556 3.069 0 5.556 2.488 5.556 5.556v2.849c0 3.069-2.487 5.556-5.556 5.556z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.951 152.151c-3.069 0-5.556-2.488-5.556-5.556v-2.849c0-3.069 2.488-5.556 5.556-5.556 3.069 0 5.556 2.488 5.556 5.556v2.849c0 3.069-2.487 5.556-5.556 5.556z",
    fill: "url(#SVGID_27_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m357.804 160.231h-3.78c-3.151 0-5.536-2.847-4.984-5.949l2.167-12.182h9.414l2.167 12.182c.552 3.102-1.833 5.949-4.984 5.949z",
    fill: "url(#SVGID_28_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m346.642 116.187c0 12.569-10.189 22.758-22.758 22.758-6.691 0-11.553-6.468-9.579-12.861 2.259-7.318 6.396-13.811 11.848-18.918 7.762-7.272 20.489-1.615 20.489 9.021z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.103 108.13c0-5.672 3.979-10.537 9.521-11.744 2.998-.653 6.112-.997 9.306-.997 19.54 0 36.076 12.868 41.594 30.592 2.002 6.431-2.814 12.964-9.55 12.964h-20.056c-17.019 0-30.815-13.796-30.815-30.815z",
    fill: "url(#SVGID_30_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m194.099 339.342h-80.026v-76.486c0-22.099 17.914-40.013 40.013-40.013 22.099 0 40.013 17.914 40.013 40.013z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.097 344.019c0-18.897 15.319-34.215 34.215-34.215h17.546c18.897 0 34.215 15.319 34.215 34.215z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m111.324 275.003c0-5.594 3.883-10.281 9.101-11.513 1.395-.329 2.728.749 2.728 2.182v18.66c0 1.433-1.333 2.512-2.728 2.182-5.218-1.23-9.101-5.917-9.101-11.511z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.848 275.003c0-5.594-3.883-10.281-9.101-11.513-1.395-.329-2.728.749-2.728 2.182v18.66c0 1.433 1.333 2.512 2.728 2.182 5.218-1.23 9.101-5.917 9.101-11.511z",
    fill: "url(#SVGID_34_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m154.086 318.577c-18.897 0-34.215-15.319-34.215-34.215v-17.546c0-18.897 15.319-34.215 34.215-34.215 18.897 0 34.215 15.319 34.215 34.215v17.546c.001 18.896-15.318 34.215-34.215 34.215z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.086 307.53c-6.285 0-11.552-4.363-12.936-10.226-.37-1.567.842-3.065 2.452-3.065h20.967c1.61 0 2.822 1.498 2.452 3.065-1.383 5.863-6.65 10.226-12.935 10.226z",
    fill: "url(#SVGID_36_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m140.049 280.522c-3.069 0-5.556-2.488-5.556-5.556v-2.849c0-3.069 2.488-5.556 5.556-5.556 3.069 0 5.556 2.488 5.556 5.556v2.849c0 3.069-2.487 5.556-5.556 5.556z",
    fill: "url(#SVGID_37_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.123 280.522c-3.069 0-5.556-2.488-5.556-5.556v-2.849c0-3.069 2.488-5.556 5.556-5.556 3.069 0 5.556 2.488 5.556 5.556v2.849c.001 3.069-2.487 5.556-5.556 5.556z",
    fill: "url(#SVGID_38_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m155.976 288.602h-3.78c-3.151 0-5.536-2.847-4.984-5.949l2.167-12.182h9.414l2.167 12.182c.552 3.102-1.833 5.949-4.984 5.949z",
    fill: "url(#SVGID_39_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m191.059 264.762c-11.28 1.01-23.8 1.58-36.97 1.58-13.18 0-25.7-.57-36.98-1.59.58-16.39 11.83-30.06 27.01-34.3 3.17-.89 6.51-1.36 9.97-1.36s6.8.47 9.97 1.36c6.21 1.73 11.77 5.05 16.2 9.48 6.4 6.41 10.46 15.14 10.8 24.83z",
    fill: "url(#SVGID_40_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m312.925 344.019c0-18.897 15.319-34.215 34.215-34.215h17.546c18.897 0 34.215 15.319 34.215 34.215z",
    fill: "url(#SVGID_41_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m313.152 275.003c0-5.594 3.883-10.281 9.101-11.513 1.395-.329 2.728.749 2.728 2.182v18.66c0 1.433-1.333 2.512-2.728 2.182-5.218-1.23-9.101-5.917-9.101-11.511z",
    fill: "url(#SVGID_42_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.676 275.003c0-5.594-3.883-10.281-9.101-11.513-1.395-.329-2.728.749-2.728 2.182v18.66c0 1.433 1.333 2.512 2.728 2.182 5.218-1.23 9.101-5.917 9.101-11.511z",
    fill: "url(#SVGID_43_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m355.914 318.577c-18.897 0-34.215-15.319-34.215-34.215v-17.546c0-18.897 15.319-34.215 34.215-34.215 18.897 0 34.215 15.319 34.215 34.215v17.546c0 18.896-15.318 34.215-34.215 34.215z",
    fill: "url(#SVGID_44_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.804 288.602h-3.78c-3.151 0-5.536-2.847-4.984-5.949l2.167-12.182h9.414l2.167 12.182c.552 3.102-1.833 5.949-4.984 5.949z",
    fill: "url(#SVGID_45_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m365.664 305.592h-19.5c-2.278 0-4.125-1.847-4.125-4.125v-2c0-2.278 1.847-4.125 4.125-4.125h19.5c2.278 0 4.125 1.847 4.125 4.125v2c0 2.278-1.847 4.125-4.125 4.125z",
    fill: "url(#SVGID_46_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m343.387 277.95c-1.381 0-2.5-1.119-2.5-2.5 0-1.686-1.371-3.057-3.056-3.057-1.686 0-3.057 1.371-3.057 3.057 0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5c0-4.442 3.614-8.057 8.057-8.057s8.056 3.614 8.056 8.057c0 1.381-1.119 2.5-2.5 2.5z",
    fill: "url(#SVGID_47_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m379.554 277.95c-1.381 0-2.5-1.119-2.5-2.5 0-1.686-1.371-3.057-3.057-3.057-1.685 0-3.056 1.371-3.056 3.057 0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5c0-4.442 3.614-8.057 8.056-8.057s8.057 3.614 8.057 8.057c0 1.381-1.119 2.5-2.5 2.5z",
    fill: "url(#SVGID_48_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m325.647 273.367v-4.105c0-5.341 4.329-9.67 9.67-9.67h41.19c5.341 0 9.67 4.329 9.67 9.67v4.105c0 1.091.884 1.975 1.975 1.975 1.091 0 1.975-.884 1.975-1.975v-37.795c0-7.577-6.143-13.72-13.72-13.72h-40.99c-7.577 0-13.72 6.143-13.72 13.72v37.795c0 1.091.884 1.975 1.975 1.975 1.091 0 1.975-.884 1.975-1.975z",
    fill: "url(#SVGID_49_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupVideoCall);
export default __webpack_public_path__ + "static/media/icon-group-video-call.446d9a0ae3c3122843895614f497cd48.svg";
export { ForwardRef as ReactComponent };